export default "__VITE_ASSET__ByVKo38u__"